import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { useTranslation } from 'react-i18next'
import { WarningExclamationIcon } from '@/common/icons/general'
import { Button } from '@/common/components/Button'
import { Link, useNavigate } from 'react-router-dom'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { HomeIcon } from '@/common/icons/menu.tsx'
import { IconType } from '@/common/icons/types.ts'
import { useEffect, useRef } from 'react'
import { LogUserActivity } from '@/apis/users/requests'
import { LOG_TYPES } from '../constants'


export default function ResidencyVerifyInstructionsPage() {
  const { t: translate } = useTranslation()
  const navigateTo = useNavigate()


  const hasLoggedPageView = useRef(false);
  useEffect(() => {
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: 'Residency Verification page',
      })
      hasLoggedPageView.current = true;
    }
  }, [])

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        {translate('residency_verification')}
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content>
        <h2 className="text-xl font-medium text-gray-900 mb-10 sm:mb-5">
          {translate('residency_determine_text')}
        </h2>
        <div>
          <h3 className="flex items-center">
            <HomeIcon type={IconType.Filled} />
            <div className="ml-2 font-medium">
              {translate('residency_acceptable_docs_prompt')}
            </div>
          </h3>
          <div className="mt-4 mb-5">
            <ul className="ml-6 mt-2 text-gray-700 space-y-2 list-['-_']">
              <li>{translate('residency_docs.deed')}</li>
              <li>{translate('residency_docs.mortgage_payment')}</li>
              <li>{translate('residency_docs.lease_with_payment')}</li>
              <li>
                {translate('residency_docs.landlord_affidavit_and_payment')}
              </li>
              <li className='italic'>{translate('residency_docs.religious_affidavit')}</li>
            </ul>
            <div className="mt-6 flex items-center rounded-md px-2 py-2 text-xs font-medium ring-1 ring-inset bg-primary-50 ring-primary-600/20">
              <WarningExclamationIcon className="text-sm" />
              <span className="text-gray-600 ml-2">
                {translate('residency_docs_requirement_prompt')}
              </span>
            </div>
          </div>
        </div>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar className="flex flex-col">
        <Button
          onClick={() => {
            navigateTo(
              AppRoutePaths.family_application.residency_verification
                .document_capture
            )
          }}
          className="w-full"
        >
          {translate('upload_doc_residency')}
        </Button>

        <Link
          className="text-sm font-medium link text-primary cursor-pointer underline text-center mt-6"
          to={
            AppRoutePaths.family_application.residency_verification
              .alternative_docs_info
          }
        >
          {translate('no_residency_docs')}
        </Link>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
